import React, { useState, useEffect, useRef, useCallback } from "react";
import { useAxiosWithAuthorization } from "../../../../utils/api";
import useAppContext from "../../../../utils/Reducers";
import { ModalGradViewPop } from "../GradViewPop";

const History = ({ inspData, onClose }) => {
  const [initFields, setInitFields] = useState({
    rvndrNm: inspData?.schRvndrNm,
  });

  const [searchData, setSearchData] = useState([]);

  const [detailView, setDetailView] = useState();

  const [isShow, setIsShow] = useState(false);

  const SP_SEARCH_INSPECTION_HISTORY_LIST =
    "/mobileweb/inspection/SP_SEARCH_INSPECTION_HISTORY_LIST.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SP_SEARCH_INSPECTION_HISTORY_LIST,
    },
    { manual: true }
  );

  const handleMasterSearch = async () => {
    const {
      data: { data },
    } = await fetchData({
      url: SP_SEARCH_INSPECTION_HISTORY_LIST,
      params: {
        vhclNo: inspData?.vhclNo,
      },
    });
    //console.log(data);
    setSearchData(data);
  };

  useEffect(() => {
    handleMasterSearch();
  }, []);

  const onDetailView = (data) => {
    ModalGradViewPop({
      inspData: data,
    });
  };
  return (
    <>
      <div className="conm">
        <div id="menu2" className="list">
          {searchData &&
            searchData?.map((data, index) => {
              return (
                <div key={index} onClick={(event) => onDetailView(data)}>
                  <div className="ctitle">
                    <h1 className="carno">
                      {data.itemNm}
                      {data.itemEtcCdNm !== " " ? "/" + data.itemEtcCdNm : ""}
                    </h1>
                    <div>
                      {data.cameraCnt > 0 ? (
                        <button className="camera"></button>
                      ) : (
                        ""
                      )}
                      {data.warmCnt > 0 ? <button className="al"></button> : ""}
                      {data.outageWght > 0 ? (
                        <div className="nums">-{data.outageWght}</div>
                      ) : (
                        ""
                      )}
                      {data.returnCnt > 0 ? (
                        <button className="close"></button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="cinfo mt10">
                    <div>
                      <div className="stat done">일자</div>
                      <div>
                        <h2 className="date arrive" style={{ marginLeft: "0" }}>
                          {data.wghtDt}
                        </h2>
                      </div>
                    </div>
                    <div className="com">
                      <h2>
                        {data.vndrNm} / {data.rvndrNm}
                      </h2>
                    </div>
                  </div>
                  <div className="cinfo">
                    <div>
                      <div className="stat none"></div>
                      <div>
                        <h2 className="date arrive" style={{ marginLeft: "0" }}>
                          {data.plantNm}
                        </h2>
                      </div>
                    </div>
                    <div className="rrr">
                      <div className="stat none"></div>
                      <div>
                        <h2 className="date arrive" style={{ marginLeft: "0" }}>
                          {data.workerNm}
                        </h2>
                      </div>
                    </div>
                    <div>
                      <div className="stat test">검수</div>
                      <div>
                        <h2 className="date arrive" style={{ marginLeft: "0" }}>
                          {data.inspNo}
                        </h2>
                      </div>
                    </div>
                    <div>
                      <div className="stat ready">배차</div>
                      <div className="com">
                        <h2 className="date arrive" style={{ marginLeft: "0" }}>
                          {data.tmsOdrNo}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default History;
